import newButton from "../../../../../../packages/design-system/button/constellation/button-legacy/images/new-button.png";
import legacyButton from "../../../../../../packages/design-system/button/constellation/button-legacy/images/legacy-button.png";
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  newButton,
  legacyButton,
  SectionMessage,
  React
};